module.exports = __webpack_public_path__ + "static/media/BasketCart.19632c75.svg";